export default __webpack_public_path__ + "static/media/rubik-v12-latin-300.553d48c7.woff";